<template>
    <vx-card class="w-11/12 shadow-lg">
        <action-bar class="action-bar">
            <template v-slot:left>
                <h2>Genres</h2>
            </template>
            <template v-slot:right>
                <vx-action-icon
                    icon="PlusSquareIcon"
                    tooltip="Add Genre"
                    @click="$router.push('/genres/new')"
                >
                </vx-action-icon>
            </template>
        </action-bar>

        <vx-server-side-table
            striped
            class="px-4"
            ref="servertable"
            search
            v-model="selected"
            :fetchData="$api.genre.fetchGenres"
            :columns="columns"
            :filters.sync="customFilters"
        >
            <template v-slot:State="{ row }">
                <vx-tooltip :title="stateToolTip(row.publishState)">
                    {{ stateDescription(row.publishState) }}
                </vx-tooltip>
            </template>

            <template v-slot:Status="{ row }">
                <vx-tooltip :title="statusToolTip(row.publishingStatus)">
                    {{ statusDescription(row.publishingStatus) }}
                </vx-tooltip>
            </template>
            <template v-slot:Action="{ row }">
                <vx-action-icon
                    icon="CheckCircleIcon"
                    hover-color="success"
                    tooltip="Ready to Publish"
                    :disabled="row.publishingStatus != 0"
                    @click.stop.prevent="setReadyStatus(row)"
                />
            </template>
        </vx-server-side-table>
    </vx-card>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import publishMixins from '../mixins/publishMixins'
import { mapParams } from '@/plugins/mappers'
import { mapGetters } from 'vuex'

export default {
    name: 'genres',
    components: {
        ActionBar
    },
    data() {
        return {
            coupons: [],
            selectedX: null,
            search_text: ''
        }
    },
    mixins: [publishMixins],
    computed: {
        ...mapParams('genre_id'),
        ...mapGetters({
            edition: 'auth/edition'
        }),
        columns() {
            return [
                { title: 'Name', value: 'name', sort: 'name' },
                {
                    title: 'Header Colour',
                    value: 'headerColour',
                    sort: 'headerColour'
                },
                {
                    title: 'Interest(s)',
                    value: 'interests',
                    format: this.getMultipleInterestDescription
                },
                {
                    title: 'State',
                    value: (v) => this.stateDescription(v.publishState),
                    style: 'white-space: nowrap;',
                    sort: 'publishState'
                },
                {
                    title: 'Status',
                    value: (v) => this.statusDescription(v.publishingStatus),
                    style: 'white-space: nowrap;',
                    sort: 'publishingStatus'
                },
                { title: 'Action', value: '', style: 'width: 50px' }
            ]
        },
        selected: {
            get() {
                return this.selectedX
            },
            set(val) {
                this.selectedX = val
                this.$router.push(`/genres/${val.id}`)
            }
        },
        customFilters: {
            get() {
                return {
                    genreId:
                        this.searchGenreId && this.searchGenreId != -1 ? this.searchGenreId : null,
                    search: this.search_text
                }
            },
            set(val) {
                this.search_text = val.search
                this.searchGenreId = val.genreId ? val.genreId : -1
            }
        }
    },
    watch: {
        edition: {
            handler: function (newVal, oldVal) {
                if (!newVal.isPublishing && oldVal.isPublishing) {
                    this.$refs.servertable.reset()
                }
            }
        }
    },
    methods: {
        setReadyStatus(row) {
            try {
                var response = this.$api.genre.setReady(row)
                row.publishingStatus = 1
                this.notifySuccess('Updated successfully', 'Status set to Ready successfully', 5000)
            } catch (err) {
                console.error(err)
                this.notifyError('Error', `Error message: ${err}`, 5000)
            }
        }
    }
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
::v-deep .vs-card--content {
    min-height: 40vh;
}
</style>
